import { SipPlanStatus } from '../../../api/common.types'

/** Plan list / header / filters only when status is rolled out. */
export function isSipPlanRolledOut(planStatus?: SipPlanStatus | null): boolean {
  return planStatus === SipPlanStatus.PLAN_ROLLED_OUT
}

/** Find-your-strategy shell (questionnaire not started). */
export function isSipStrategyNotStarted(planStatus?: SipPlanStatus | null): boolean {
  return planStatus == null || planStatus === SipPlanStatus.QUESTIONNAIRE_NOT_INITIATED
}

/** Complete-your-strategy shell (questionnaire started, not submitted). */
export function isSipStrategyInProgress(planStatus?: SipPlanStatus | null): boolean {
  return planStatus === SipPlanStatus.QUESTIONNAIRE_IN_PROGRESS
}

/** Strategy CTA shell — not yet on timer (submitted / re-submitted). */
export function shouldShowSipStrategyShell(planStatus?: SipPlanStatus | null): boolean {
  return isSipStrategyNotStarted(planStatus) || isSipStrategyInProgress(planStatus)
}
